import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/$org/jobs')({
  component: JobsLayout,
  beforeLoad: async ({ location, params }) => {
    // Check if current path is the login page
    const isLoginPath = location.pathname === `/${params.org}/login`
    
    // Skip auth check for login page
    if (isLoginPath) {
      return
    }
    
    // Check authentication status from localStorage
    const storedAuthState = localStorage.getItem('authState')
    let isAuthenticated = false
    
    if (storedAuthState) {
      try {
        const parsed = JSON.parse(storedAuthState)
        isAuthenticated = parsed.isAuthenticated === true
      } catch (error) {
        console.error('Failed to parse stored auth state:', error)
      }
    }
    
    // Redirect to login if not authenticated
    if (!isAuthenticated) {
      throw redirect({
        to: '/$org/login',
        params: { org: params.org },
        search: {
          next: location.href,
          email: undefined,
          password: undefined,
        },
      })
    }
  },
})

function JobsLayout() {
  return <Outlet />
}